module.exports = __webpack_public_path__ + "static/media/givingPrize2.a4e20fea.jpeg";